<template>
  <div class="page">
    <nd-navigation>扣款账户</nd-navigation>
    <div class="repay-bank-list">
      <div
        class="item"
        v-for="item in list"
        :key="item.cardNumber"
      >
        <div
          class="card-info"
          :class="{
            invalid: item.bindStatus!== 'SUCCESS_AUTH',
          }"
          :style="{
            background: `linear-gradient(
            90deg,
            ${bankTheme[item.bankCode]
            ? bankTheme[item.bankCode][0]
            : bankTheme.DEFAULT[0]
            } 0%,
                  ${bankTheme[item.bankCode]
            ? bankTheme[item.bankCode][1]
            : bankTheme.DEFAULT[1]
            } 100%
        )`,
          }"
        >
          <img
            class="custom-icon bank-icon"
            :src="loadBankIcon(item.bankCode)"
          />
          <div class="flex">
            <div class="bank-name">{{ item.bankName }}</div>
            <div class="bankcard-no">
              {{ item.cardNumber | cardNoFilter }}
            </div>
          </div>
        </div>
        <div class="check-info">
          <span class="status" @click="addBankCard(item)"><template v-if="item.bindStatus!== 'SUCCESS_AUTH'" >银行卡已失效，请重新绑定 &gt;</template></span>
          <nd-button class="btn" @click="$router.push(`/bankcard/repay-bank-detail?cardNumber=${item.cardNumber}`)">查看订单</nd-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script >
import bankTheme from './components/bankcard/bank-theme'
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      bankTheme,
      list: []
    }
  },
  filters: {
    cardNoFilter (val) {
      let str = '************' + String(val).substr(-4)
      return str.replace(/(.{4})/g, '$1 ')
    }
  },
  computed: {},
  async created () {
    this.getBankcardList()
    this.$bus.$emit('ready')
  },
  methods: {
    ...mapActions('bankcard', ['overdueBillCardListX']),
    async getBankcardList () {
      const { success, data } = await this.overdueBillCardListX()
      if (success) {
        this.list = data || []
      }
    },
    addBankCard (item) {
      const { notBindFundPartnerCds = [], cardNumber } = item
      const params = {
        fundCode: notBindFundPartnerCds[0],
        bankcardNo: cardNumber,
        type: 'OVERDUE_BIND',
        canChangePhoneNo: true
      }
      this.$router.push({ path: '/bankcard/add', query: params })
    },
    loadBankIcon (bankCode) {
      try {
        return require(`./images/${bankCode.toLowerCase()}.jpg`)
      } catch (e) {}
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.repay-bank-list {
  min-height: 100vh;
  background: #fafafa;
  padding: 40px;
  .item {
    margin-bottom: 40px;
  }
  .card-info {
    display: flex;
    align-items: flex-start;
    overflow: hidden;
    height: 210px;
    border-radius: 30px;
    color: #fff;
    border-bottom-left-radius: 0%;
    border-bottom-right-radius: 0%;
    padding: 40px;
    &.invalid {
      background: linear-gradient(
        90deg,
        #D3D3D3 0%,
        #E2E2E1 100%
      ) !important;
    }
    .bank-icon {
      height: 50px;
      width: 50px;
      border-radius: 50%;
      margin-right: 18px;
    }
    .flex {
      flex: 1;
      .bank-name {
        font-size: 32px;
        font-weight: 400;
        line-height: 50px;
      }
      .bankcard-no {
        margin-top: 10px;
        font-size: 50px;
        font-family: DIN-Medium, DIN;
        font-weight: 500;
        line-height: 60px;
      }
    }
  }
  .check-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 28px 40px;
      border-radius: 0 0 30px 30px;
      background: #fff;
      border-bottom: 1px solid #ebebeb;
      border-top: 0;
      
      .status {
        height: 33px;
        font-size: 24px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #FB4A46;
        line-height: 33px;
      }
      .btn {
        width: 143px;
        height: 48px;
        line-height: 48px;
        border-radius: 28px;
        border: 1px solid #999999;
        background: #fff;
        font-size: 24px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #333333;
      }
    }
}
</style>